import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.set.difference.v2.js";
import "core-js/modules/es.set.intersection.v2.js";
import "core-js/modules/es.set.is-disjoint-from.v2.js";
import "core-js/modules/es.set.is-subset-of.v2.js";
import "core-js/modules/es.set.is-superset-of.v2.js";
import "core-js/modules/es.set.symmetric-difference.v2.js";
import "core-js/modules/es.set.union.v2.js";
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, vModelCheckbox as _vModelCheckbox, createTextVNode as _createTextVNode, Teleport as _Teleport, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  key: 0,
  class: "fixed inset-0 z-[10000] overflow-hidden"
};
const _hoisted_2 = {
  class: "absolute inset-y-0 right-0 flex w-full max-w-2xl flex-col bg-white shadow-2xl"
};
const _hoisted_3 = {
  class: "flex items-center justify-between border-b border-slate-200 px-5 py-4 sm:px-6"
};
const _hoisted_4 = {
  class: "flex items-center gap-3"
};
const _hoisted_5 = {
  class: "flex h-10 w-10 items-center justify-center rounded-lg bg-blue-50"
};
const _hoisted_6 = {
  class: "border-b border-slate-200 bg-slate-50 px-5 py-4 sm:px-6"
};
const _hoisted_7 = {
  class: "grid gap-3 sm:grid-cols-2 lg:grid-cols-3"
};
const _hoisted_8 = {
  class: "flex items-end"
};
const _hoisted_9 = ["disabled"];
const _hoisted_10 = {
  class: "min-h-0 flex-1 overflow-y-auto px-5 py-4 sm:px-6"
};
const _hoisted_11 = {
  key: 0,
  class: "flex flex-col items-center gap-3 py-16 text-center"
};
const _hoisted_12 = {
  key: 1,
  class: "flex flex-col items-center gap-3 py-16 text-center"
};
const _hoisted_13 = {
  class: "flex h-12 w-12 items-center justify-center rounded-full bg-rose-100"
};
const _hoisted_14 = {
  key: 2,
  class: "flex flex-col items-center gap-3 py-16 text-center"
};
const _hoisted_15 = {
  class: "empty-state-icon"
};
const _hoisted_16 = {
  key: 3,
  class: "space-y-2"
};
const _hoisted_17 = ["value"];
const _hoisted_18 = {
  class: "min-w-0 flex-1"
};
const _hoisted_19 = {
  class: "block break-words text-sm font-medium text-slate-800"
};
const _hoisted_20 = {
  class: "mt-1.5 flex flex-wrap gap-x-4 gap-y-1 text-xs text-slate-400"
};
const _hoisted_21 = {
  class: "inline-flex items-center gap-1"
};
const _hoisted_22 = {
  class: "inline-flex items-center gap-1"
};
const _hoisted_23 = {
  class: "inline-flex items-center gap-1"
};
const _hoisted_24 = {
  class: "flex items-center justify-between border-t border-slate-200 bg-slate-50/80 px-5 py-4 sm:px-6"
};
const _hoisted_25 = {
  class: "rounded-md bg-blue-50 px-2.5 py-1 text-sm font-medium text-blue-700"
};
const _hoisted_26 = {
  class: "flex gap-2"
};
const _hoisted_27 = ["disabled"];
import { reactive, ref, watch } from 'vue';
import { ElMessage } from 'element-plus';
import { ClipboardDocumentListIcon, ExclamationTriangleIcon, XMarkIcon } from '@heroicons/vue/24/outline';
import { getReportableTodos } from '@/api/workReport';
import { normalizeReportTodoSnapshot, normalizeTodoStatusCode, workReportPriorityLabel, workReportTodoStatusLabel } from '../workReportUtils';
export default {
  __name: 'TodoPickerDrawer',
  props: {
    modelValue: {
      type: Boolean,
      default: false
    },
    selectedTodoIds: {
      type: Array,
      default: () => []
    }
  },
  emits: ['update:modelValue', 'confirm'],
  setup(__props, {
    emit: __emit
  }) {
    const props = __props;
    const emit = __emit;
    const loading = ref(false);
    const loadError = ref(false);
    const todos = ref([]);
    const selectedIds = ref([]);
    const filters = reactive({
      status: '',
      priority: '',
      keyword: '',
      dueDateStart: '',
      dueDateEnd: ''
    });
    const REPORTABLE_TODO_STATUS_CODES = new Set([0, 2, 4]);
    watch(() => props.modelValue, visible => {
      if (!visible) return;
      selectedIds.value = [...props.selectedTodoIds];
      loadTodos();
    });
    async function loadTodos() {
      loading.value = true;
      loadError.value = false;
      try {
        const result = await getReportableTodos(buildReportableTodoQuery());
        const records = Array.isArray(result) ? result : result?.records || result?.list || result?.rows || result?.data || [];
        todos.value = records.map(normalizePickerTodo).filter(Boolean).filter(matchesSelectedStatus);
      } catch {
        loadError.value = true;
        ElMessage.error('待办加载失败，请重试');
      } finally {
        loading.value = false;
      }
    }
    function buildReportableTodoQuery() {
      return {
        priority: filters.priority || undefined,
        keyword: filters.keyword || undefined,
        dueDateStart: filters.dueDateStart ? `${filters.dueDateStart}T00:00:00` : undefined,
        dueDateEnd: filters.dueDateEnd ? `${filters.dueDateEnd}T23:59:59` : undefined
      };
    }
    function normalizePickerTodo(todo) {
      const snapshot = normalizeReportTodoSnapshot(todo);
      if (!snapshot?.todoId || !REPORTABLE_TODO_STATUS_CODES.has(normalizeTodoStatusCode(snapshot.status))) {
        return null;
      }
      return {
        ...todo,
        id: snapshot.todoId,
        todoId: snapshot.todoId,
        title: snapshot.title,
        description: snapshot.description,
        priority: snapshot.priority,
        dueDate: snapshot.dueDate,
        status: snapshot.status,
        completeTime: snapshot.completeTime,
        updateTime: snapshot.updateTime
      };
    }
    function matchesSelectedStatus(todo) {
      if (!filters.status) return true;
      return normalizeTodoStatusCode(todo.status) === Number(filters.status);
    }
    function close() {
      emit('update:modelValue', false);
    }
    function confirm() {
      const selected = todos.value.filter(todo => selectedIds.value.includes(todo.id));
      emit('confirm', selected);
      close();
    }
    return (_ctx, _cache) => {
      const _component_el_option = _resolveComponent("el-option");
      const _component_el_select = _resolveComponent("el-select");
      return _openBlock(), _createBlock(_Teleport, {
        to: "body"
      }, [__props.modelValue ? (_openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", {
        class: "absolute inset-0 bg-slate-900/60 backdrop-blur-sm",
        onClick: close
      }), _createElementVNode("section", _hoisted_2, [_createElementVNode("header", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [_createVNode(_unref(ClipboardDocumentListIcon), {
        class: "h-5 w-5 text-blue-600"
      })]), _cache[6] || (_cache[6] = _createElementVNode("div", {
        class: "min-w-0"
      }, [_createElementVNode("h3", {
        class: "truncate text-lg font-semibold text-slate-900"
      }, "从待办添加"), _createElementVNode("p", {
        class: "mt-0.5 text-sm text-slate-500"
      }, "仅选择待办，不会修改待办状态。")], -1))]), _createElementVNode("button", {
        type: "button",
        class: "rounded-lg p-1.5 text-slate-400 transition-colors hover:bg-slate-100 hover:text-slate-600",
        title: "关闭",
        onClick: close
      }, [_createVNode(_unref(XMarkIcon), {
        class: "h-5 w-5"
      })])]), _createElementVNode("div", _hoisted_6, [_createElementVNode("div", _hoisted_7, [_createElementVNode("label", null, [_cache[7] || (_cache[7] = _createElementVNode("span", {
        class: "form-label"
      }, "状态", -1)), _createVNode(_component_el_select, {
        modelValue: filters.status,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => filters.status = $event),
        class: "form-select form-control-sm mt-1 w-full",
        onChange: loadTodos
      }, {
        default: _withCtx(() => [_createVNode(_component_el_option, {
          label: "全部",
          value: ""
        }), _createVNode(_component_el_option, {
          label: "待办",
          value: "0"
        }), _createVNode(_component_el_option, {
          label: "进行中",
          value: "4"
        }), _createVNode(_component_el_option, {
          label: "已逾期",
          value: "2"
        })]),
        _: 1
      }, 8, ["modelValue"])]), _createElementVNode("label", null, [_cache[8] || (_cache[8] = _createElementVNode("span", {
        class: "form-label"
      }, "优先级", -1)), _createVNode(_component_el_select, {
        modelValue: filters.priority,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => filters.priority = $event),
        class: "form-select form-control-sm mt-1 w-full",
        onChange: loadTodos
      }, {
        default: _withCtx(() => [_createVNode(_component_el_option, {
          label: "全部",
          value: ""
        }), _createVNode(_component_el_option, {
          label: "低",
          value: "1"
        }), _createVNode(_component_el_option, {
          label: "中",
          value: "2"
        }), _createVNode(_component_el_option, {
          label: "高",
          value: "3"
        }), _createVNode(_component_el_option, {
          label: "紧急",
          value: "4"
        })]),
        _: 1
      }, 8, ["modelValue"])]), _createElementVNode("label", null, [_cache[9] || (_cache[9] = _createElementVNode("span", {
        class: "form-label"
      }, "关键词", -1)), _withDirectives(_createElementVNode("input", {
        "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => filters.keyword = $event),
        class: "form-input form-control-sm mt-1 w-full",
        placeholder: "搜索标题",
        onKeyup: _withKeys(loadTodos, ["enter"])
      }, null, 544), [[_vModelText, filters.keyword, void 0, {
        trim: true
      }]])]), _createElementVNode("label", null, [_cache[10] || (_cache[10] = _createElementVNode("span", {
        class: "form-label"
      }, "到期日开始", -1)), _withDirectives(_createElementVNode("input", {
        "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => filters.dueDateStart = $event),
        type: "date",
        class: "form-input form-control-sm mt-1 w-full",
        onChange: loadTodos
      }, null, 544), [[_vModelText, filters.dueDateStart]])]), _createElementVNode("label", null, [_cache[11] || (_cache[11] = _createElementVNode("span", {
        class: "form-label"
      }, "到期日结束", -1)), _withDirectives(_createElementVNode("input", {
        "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => filters.dueDateEnd = $event),
        type: "date",
        class: "form-input form-control-sm mt-1 w-full",
        onChange: loadTodos
      }, null, 544), [[_vModelText, filters.dueDateEnd]])]), _createElementVNode("div", _hoisted_8, [_createElementVNode("button", {
        type: "button",
        class: "btn-secondary w-full",
        disabled: loading.value,
        onClick: loadTodos
      }, _toDisplayString(loading.value ? '搜索中' : '搜索'), 9, _hoisted_9)])])]), _createElementVNode("main", _hoisted_10, [loading.value ? (_openBlock(), _createElementBlock("div", _hoisted_11, [...(_cache[12] || (_cache[12] = [_createElementVNode("div", {
        class: "app-spinner"
      }, null, -1), _createElementVNode("span", {
        class: "text-sm text-slate-500"
      }, "正在加载待办...", -1)]))])) : loadError.value ? (_openBlock(), _createElementBlock("div", _hoisted_12, [_createElementVNode("div", _hoisted_13, [_createVNode(_unref(ExclamationTriangleIcon), {
        class: "h-6 w-6 text-rose-500"
      })]), _cache[13] || (_cache[13] = _createElementVNode("p", {
        class: "text-sm text-slate-600"
      }, "待办加载失败，请重试。", -1)), _createElementVNode("button", {
        type: "button",
        class: "btn-secondary",
        onClick: loadTodos
      }, "重试")])) : todos.value.length === 0 ? (_openBlock(), _createElementBlock("div", _hoisted_14, [_createElementVNode("div", _hoisted_15, [_createVNode(_unref(ClipboardDocumentListIcon), {
        class: "h-6 w-6 text-slate-300"
      })]), _cache[14] || (_cache[14] = _createElementVNode("span", {
        class: "empty-state-title"
      }, "暂无可选择的待办", -1))])) : (_openBlock(), _createElementBlock("div", _hoisted_16, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(todos.value, todo => {
        return _openBlock(), _createElementBlock("label", {
          key: todo.id,
          class: "flex cursor-pointer items-start gap-3 rounded-xl border border-slate-200 px-4 py-3.5 transition-all duration-200 hover:border-blue-300 hover:bg-blue-50/30 hover:shadow-sm"
        }, [_withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => selectedIds.value = $event),
          class: "form-check mt-0.5",
          type: "checkbox",
          value: todo.id
        }, null, 8, _hoisted_17), [[_vModelCheckbox, selectedIds.value]]), _createElementVNode("span", _hoisted_18, [_createElementVNode("span", _hoisted_19, _toDisplayString(todo.title), 1), _createElementVNode("span", _hoisted_20, [_createElementVNode("span", _hoisted_21, [_cache[15] || (_cache[15] = _createElementVNode("span", {
          class: "h-1.5 w-1.5 rounded-full bg-slate-300"
        }, null, -1)), _createTextVNode(" 状态：" + _toDisplayString(_unref(workReportTodoStatusLabel)(todo.status)), 1)]), _createElementVNode("span", _hoisted_22, [_cache[16] || (_cache[16] = _createElementVNode("span", {
          class: "h-1.5 w-1.5 rounded-full bg-slate-300"
        }, null, -1)), _createTextVNode(" 优先级：" + _toDisplayString(_unref(workReportPriorityLabel)(todo.priority)), 1)]), _createElementVNode("span", _hoisted_23, [_cache[17] || (_cache[17] = _createElementVNode("span", {
          class: "h-1.5 w-1.5 rounded-full bg-slate-300"
        }, null, -1)), _createTextVNode(" 到期：" + _toDisplayString(todo.dueDate || '--'), 1)])])])]);
      }), 128))]))]), _createElementVNode("footer", _hoisted_24, [_createElementVNode("span", _hoisted_25, "已选择 " + _toDisplayString(selectedIds.value.length) + " 项", 1), _createElementVNode("div", _hoisted_26, [_createElementVNode("button", {
        type: "button",
        class: "btn-secondary",
        onClick: close
      }, "取消"), _createElementVNode("button", {
        type: "button",
        class: "btn-primary",
        disabled: selectedIds.value.length === 0,
        onClick: confirm
      }, "添加", 8, _hoisted_27)])])])])) : _createCommentVNode("", true)]);
    };
  }
};